/** Fired when the server may have changed the user's alerts (a conversation was read). */
export const NOTIFICATIONS_CHANGED = 'ridalo:notifications-changed';
export const notifyNotificationsChanged = () => {
  try { window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED)); } catch { /* no window */ }
};
